import React from "react"
import {Box} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core"


export default function checkerColumn(name) {
	return {
		name: name,
		render: value => <Box sx={{  display: 'flex', justifyContent: 'center'  }}>
			<IconSeeker
				icon={ value ? "check-to-slot" : "xmark-to-slot" }
				sx={{  color: value ? "success.main" : "error.main", fontSize: "1.5rem"  }}
			/>
		</Box>
	}
}